'use client';

export const config = {
    defaultData: {
        id: '', // 活动id
        titleColor: '#000',
        subTitleColor: '#949494',
        themeColor: '#FF4D15',
        ruleColor: '#000',
        ruleBgColor: '#F4F4F4',
        image: '',
        mobileImage: '',
        loginType: 'page',
    },
};

export type DicType = {
    label?: string | number;
    value: string | undefined;
};

export const OtherOpthions: DicType[] = [
    {
        value: '_others',
        label: '自定义',
    },
];

export const GrayOpthions: DicType[] = [
    {
        value: '#949494',
        label: '灰色',
    },
    ...OtherOpthions,
];

export const BlackOpthions: DicType[] = [
    {
        value: '#000',
        label: '黑色',
    },
    ...OtherOpthions,
];
